<template>
	<div v-if="!form_submit">
		<div class="common-header-wrap">
			<mt-header :title="$t('order.confirm_mission')" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.push({ name: 'MemberO2oErrandSend' })"></mt-button>
			</mt-header>
		</div>
		<Card :noHeader="true" v-if="isErrandOrderSend">
			<template #content>
				<div class="card-item">
					<div class="card-item-label">{{ $t('order.principal') }}</div>
					<div class="card-item-value">
						<span class="highlight">
							{{ order.o2o_errand_order_pickup_name }}
							{{ order.o2o_errand_order_pickup_phone }}
						</span>
					</div>
				</div>
				<div class="card-item">
					<div class="notice">有問題會聯絡您，請保持電話暢通</div>
				</div>
				<div class="card-item">
					<div class="hr-text"></div>
				</div>
				<div class="card-item">
					<span class="card-item-label">{{ $t('order.o2o_errand_send.consignee') }}</span>
					<div class="card-item-value">
						<span class="highlight">
							{{ order.o2o_errand_order_deliver_name }}
							{{ order.o2o_errand_order_deliver_phone }}
						</span>
					</div>
				</div>
				<div class="card-item">
					<div class="hr-text"></div>
				</div>
				<div class="card-item">
					<div class="card-item-label">
						{{ $t('order.o2o_errand_send.deliver_address') }}
					</div>
					<div class="card-item-value">
						<span class="highlight">{{ order.o2o_errand_order_deliver_address }}</span>
					</div>
				</div>
				<div class="card-item">
					<div class="hr-text"></div>
				</div>
				<div class="card-item">
					<div class="card-item-label">
						{{ $t('order.o2o_errand_send.appointment_time') }}
					</div>
					<div class="card-item-value">
						<span class="highlight">
							{{ order.o2o_errand_order_appointment_time | appointmentTimeFilter }}
						</span>
					</div>
				</div>
				<div class="card-item">
					<div class="hr-text"></div>
				</div>
				<div class="card-item">
					<div class="card-item-label">
						{{ $t('order_detail.payment') }}
					</div>
					<div class="card-item-value">
						<div class="highlight" @click="showPaymentDialog">
							<i class="iconfont icon-qiehuanqiyou"></i>
							{{ display_payment_full_text }}
						</div>
					</div>
				</div>
				<div class="card-item">
					<div class="hr-text"></div>
				</div>
				<div class="card-item">
					<div class="card-item-label">
						{{ $t('order_detail.invoice') }}
					</div>
					<div class="card-item-value">
						<div class="highlight" @click="showInvoiceDialog">
							<i class="iconfont icon-qiehuanqiyou"></i>
							{{ display_invoice_full_text }}
						</div>
					</div>
				</div>
			</template>
		</Card>

		<mt-button
			type="primary"
			class="mt-10 ds-button-large"
			size="large"
			ref="confirm"
			:disabled="confirmDisabled"
			@click="confirm"
			>{{ $t('general.confirm') }}</mt-button
		>

		<mt-popup v-model="visible.payment_dialog" position="bottom" style="border-radius: 35px 35px 0 0;">
			<shopPaymentDialog @updatePayment="updatePayment"></shopPaymentDialog>
		</mt-popup>

		<mt-popup v-model="visible.invoice_dialog" position="bottom" style="border-radius: 35px 35px 0 0;">
			<shopInvoiceDialog @updateInvoice="updateInvoice"></shopInvoiceDialog>
		</mt-popup>

		<mt-popup v-model="visible.final_dialog" position="bottom" style="background: rgb(244, 196, 30); border-radius: 35px 35px 0 0;">
			<shopFinalDialog @closeFinalConfirm="confirmCancel"></shopFinalDialog>
		</mt-popup>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { pay, getPaymentList } from '../../../api/memberPayment'
import { getRechargeInfo } from '../../../api/memberRecharge'
import { getErrandOrderPay } from '../../../api/memberO2oErrand'
import { getFuwuOrderPay } from '../../../api/memberO2oFuwuOrder'
import shopPaymentDialog from '@/components/member/buy/common/shop-payment-dialog'
import shopFinalDialog from '@/components/member/buy/common/shop-final-dialog'
import shopInvoiceDialog from '@/components/member/buy/common/shop-invoice-dialog'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { appointmentTimeFilter } from '@src/util/filter'
import { addErrandOrder } from '@/api/memberO2oErrand'
import Card from '@/components/basic/card'
import { PayType } from '@/const/payment'
import { ErrandOrderType } from '@/const/order'
import { InvoiceState } from '@/const/member'

export default {
	name: 'pay',
	props: {
		order: {
			type: Object,
			required: false
		}
	},
	filters: {
		appointmentTimeFilter
	},
	data () {
		return {
			confirmDisabled: false,
			visible: {
				payment_dialog: this.$route.query.payment_dialog || false,
				final_dialog: false,
				invoice_dialog: false,
			},
			confirm_timer: undefined,
			uniapp: 0,
			pay_sn: this.$route.query.pay_sn || undefined,
			pay_type: this.$route.query.pay_type || undefined,
			form_submit: this.$route.query.submit || false,
			// 订单支付显示的数据
			pay_info: null,
			// 提交支付需要用到的数据
			payment_info: {
				password: '', // 支付密码
				rcb_pay: 0, // 是否使用充值卡进行支付
				pd_pay: 0, // 是否使用预存款进行支付
				payment_code: 'credit_h5', // 支付方式,
				payment_name: '請選擇' // 預設顯示付款方式文字
			},
			invoice_info: null,
			payment_list: [],
			showNotice: 0,
			notice: this.$route.query.notice,
			ifLoaded: 0
		}
	},
	components: {
		shopPaymentDialog,
		shopFinalDialog,
		shopInvoiceDialog,
		Card
	},
	computed: {
		...mapState({
			token: (state) => state.member.token
		}),
		display_payment_full_text: function () {
			return this.payment_info.payment_name + (this.payment_info.description || '')
		},
		display_invoice_full_text: function () {
			if (!this.invoice_info)
				return ''

			if (this.invoice_info.invoice_state == InvoiceState.PLATFORM_CARRIER) {
				return this.$t('invoice.platform_carrier') + ' ' + this.$t('invoice.platform_carrier_note')
			}
			else if (this.invoice_info.invoice_state == InvoiceState.CARRIER) {
				return this.$t('invoice.carrier') + ' ' + this.invoice_info.invoice_code
			}
			else if (this.invoice_info.invoice_state == InvoiceState.TAX_NUMBER) {
				return `${this.$t('invoice.tax_id_number')} ${this.invoice_info.invoice_company_code} ${this.invoice_info.invoice_company}`
			}
			else {
				return ''
			}
		},
		isErrandOrderSend: function () {
			return this.pay_type === PayType.O2O_ERRAND_PAY_NEW
		}
	},
	created: function () {
		this.getPaymentList()
		if (this.pay_type === 'o2o_errand_pay_new' && this.order === undefined) {
			return this.goBack()
		}
		this.gotoBottom()
		if (this.pay_sn) {
			this.getMemberPayInfo()
		}

		if (this.form_submit) {
			this.submit()
		}
	},
	watch: {
		showNotice: function (val) {
			if (val && this.notice) {
				MessageBox.confirm(
					'如果您已完成支付，请点击“完成付款”按钮，如果您未完成支付，请点击“重新支付”重新发起支付',
					'确认支付是否完成',
					{ cancelButtonText: '重新支付', confirmButtonText: '完成付款' }
				).then((action) => {
					this.goNext()
				})
			}
		},
		ifLoaded: function (val) {
			if (val >= 2) {
				this.getPaymentList()
			}
		},
		payment_list: function (val) {
			if (val && val.length > 0) {
				const defaultPayment = val.filter(v => v.is_default === 1)[0] || undefined
				if (defaultPayment) {
					this.payment_info = defaultPayment
				}
			}
		}
	},
	methods: {
		...mapActions({
			clearShopInfo: 'clearShopInfo',
			openPaymentConfirmModal: 'openPaymentConfirmModal'
		}),
		showPaymentDialog () {
			this.visible.payment_dialog = true
		},
		showInvoiceDialog () {
			this.visible.invoice_dialog = true
		},
		updatePayment (payload) {
			// 取消不做變更資料
			if (payload) {
				this.payment_info = Object.assign({}, payload)
			}
			this.visible.payment_dialog = false
		},
		updateInvoice (payload) {
			// 取消不做變更資料
			if (payload) {
				this.invoice_info = Object.assign({}, payload)
			}
			this.visible.invoice_dialog = false
		},
		setClass (code) {
			let obj = {}
			obj['icon ' + code] = true
			return obj
		},
		goBack () {
			if (this.notice) {
				this.$router.go(-2)
			} else {
				this.$router.go(-1)
			}
		},
		gotoBottom () {
			const _this = this
			this.$nextTick(() => {
				_this.$refs.confirm.scrollTop = _this.$refs.confirm.scrollHeight
			})
		},
		goNext () {
			if (this.pay_type === 'pay_new' || this.pay_type === 'o2o_errand_pay_new') {
				this.$router.push({ name: 'MemberOrderList' })
			} else if (this.pay_type === 'o2o_fuwu_pay_new') {
				this.$router.push({ name: 'MemberO2oFuwuOrderList' })
			} else if (this.pay_type === 'pd_pay') {
				this.$router.push({ name: 'MemberRechargeList' })
			}
		},
		confirm () {
			this.confirmDisabled = true;
			// payment_info.data 為信用卡資料 若無資料則跳出提醒視窗
			if (typeof this.payment_info.data === "undefined") {
				MessageBox.alert(this.$t('order.alerts.no_payment'), '')
				this.confirmDisabled = false
				return
			}

			this.openPaymentConfirmModal({
				createOrderPayload: Object.assign({
					orderType: ErrandOrderType.SEND,
					paymentCode: this.payment_info.payment_code,
					invoiceId: this.invoice_info.invoice_id,
				}, this.order)
			})

			this.confirmDisabled = false
		},
		confirmCancel (from) {
			clearTimeout(this.confirm_timer)
			this.visible.final_dialog = false

			if (from === 'button' && this.form_submit) {
				this.goBack()
			}
		},
		payType (code) {
			this.payment_info.payment_code = code
		},
		getPaymentList () {
			getPaymentList('h5', this.payment_info.payment_code)
				.then((res) => {
					this.payment_list = res.result.payment_list
					if (this.payment_list.length) {
						this.payment_info.payment_code = this.payment_list[0].payment_code
					}
				})
				.catch(function (error) {
					Toast(error.message)
				})
		},
		getMemberPayInfo () {
			let _this = this
			if (this.pay_type == 'pay_new') {
				Indicator.open({
					text: this.$route.query.payment_name + this.$t('general.authorizing')
				})
				// getOrderpayInfo(
				//   this.pay_sn
				// ).then((res) => {
				//   if (res.code === 10000) {
				// 	this.pay_info = res.result.pay_info
				//   }
				//   this.showNotice=1
				// }).catch(function (error) {
				//   if (error.code === 12001) { // 订单已经支付
				// 	_this.goNext()
				//   } else {
				// 	Toast(error.message)
				//   }
				// })
				setTimeout(() => {
					Indicator.close()
					pay(this.pay_sn, 'pay_new', this.payment_info, this.token, this.uniapp)
						.then((res) => {
							if (res.code) {
								if (res.code === 10000 || res.code === 12001) {
									this.clearShopInfo()
									this.goNext()
								} else {
									Toast(res.message)
								}
							} else {
								document.write(res)
							}
						})
						.catch(function (error) {
							if (error.message) {
								Toast(error.message)
							} else {
								document.write(error)
							}
						})
				}, 3000)
			} else if (this.pay_type == 'pd_pay') {
				getRechargeInfo(this.pay_sn)
					.then((res) => {
						if (res.code === 10000) {
							this.pay_info = {
								payment_list: res.result.payment_list,
								pay_amount: res.result.pdinfo.pdr_amount
							}
						}
						this.showNotice = 1
					})
					.catch(function (error) {
						if (error.code === 12001) {
							// 订单已经支付
							_this.goNext()
						} else {
							Toast(error.message)
						}
					})
			} else if (this.pay_type == 'o2o_errand_pay_new') {
				getErrandOrderPay(this.pay_sn)
					.then((res) => {
						if (res.code === 10000) {
							this.pay_info = {
								pay_amount: res.result.o2o_errand_order_info.api_pay_amount
							}
						}
						this.showNotice = 1
					})
					.catch(function (error) {
						if (error.code === 51001) {
							// 订单已经支付
							_this.goNext()
						} else {
							Toast(error.message)
						}
					})
			} else if (this.pay_type == 'o2o_fuwu_pay_new') {
				getFuwuOrderPay(this.pay_sn)
					.then((res) => {
						if (res.code === 10000) {
							this.pay_info = {
								payment_list: res.result.payment_list,
								pay_amount: res.result.o2o_fuwu_order_info.api_pay_amount
							}
						}
						this.showNotice = 1
					})
					.catch(function (error) {
						if (error.code === 31001) {
							// 订单已经支付
							_this.goNext()
						} else {
							Toast(error.message)
						}
					})
			}
		},
		submitForO2oErrandPayNew () {
			return new Promise(async (resolve, reject) => {
				if (this.pay_type !== 'o2o_errand_pay_new') {
					reject(new Error('Pay type isn\'t o2o_errand_pay_new.'))
				}

				try {
					if (!this.pay_sn) {
						let res = await addErrandOrder(this.order)
						this.pay_sn = res.result.pay_sn
					}
					await this.getMemberPayInfo()
					resolve()
				} catch (err) {
					reject(err)
				}
			})
		},
		async submit () {
			// dcloud.net - uni-app 小程序使用
			//   if (this.ifLoaded < 2) {
			//     Toast('请等待文件加载完成')
			//     return
			//   }
			//   let _this = this
			//   uni.getEnv(function (res) {
			//     if (res.plus) {
			//       _this.uniapp = 1
			//     }
			//   })
			if (this.payment_info.pd_pay || this.payment_info.rcb_pay) {
				if (!this.pay_info.member_paypwd) {
					MessageBox.confirm('您需要先去设置支付密码', '').then((action) => {
						this.$router.push({ name: 'MemberSetting' })
					})
				} else {
					if (!this.payment_info.password) {
						MessageBox.prompt(
							'<b>请输入支付密码</b><br/>注：默认支付密码为：123456',
							'',
							{
								showCancelButton: true,
								inputType: 'password'
							}
						).then(({ value, action }) => {
							this.payment_info.password = value
							this.submit()
						})
						return
					}
				}
			} else if (this.isErrandOrderSend) {
				try {
					await this.submitForO2oErrandPayNew()
				} catch (err) {
					return this.$alert.error(err.message)
				}
			}
			var param =
				'action=' +
				this.pay_type +
				'&key=' +
				this.token +
				'&pay_sn=' +
				this.pay_sn +
				'&password=' +
				this.payment_info.password +
				'&rcb_pay=' +
				this.payment_info.rcb_pay +
				'&pd_pay=' +
				this.payment_info.pd_pay +
				'&payment_code=' +
				this.payment_info.payment_code
			if (this.payment_info.payment_code == 'wxpay_minipro') {
				wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
				return
			}
			if (this.uniapp) {
				uni.redirectTo({ url: 'pay?' + param })
				return
			}
			pay(this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp)
				.then((res) => {
					if (res.code) {
						if (res.code === 10000 || res.code === 12001) {
							this.goNext()
						} else {
							Toast(res.message)
						}
					} else {
						document.write(res)
					}
				})
				.catch(function (error) {
					if (error.message) {
						Toast(error.message)
					} else {
						document.write(error)
					}
				})
		}
	}
}
</script>

<style scoped lang="scss">
.common-header {
	background-color: #f4c41e;
	color: black;
}
.card-item {
	margin: 0.5rem;
}
.highlight {
	color: #EC9027;
	font-weight: 600;
	font-size: 0.8rem;
}
.notice {
	color: gray;
	font-size: 0.6rem;
}

.container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: $mainbgColor;
}
.bottom-wrapper {
	background: #fff;
	position: absolute;
	width: 100%;
	padding: 0.5rem $pageSpace;
	box-sizing: border-box;
	bottom: 0;
	left: 0;
}
.main-content {
	padding: 0 $pageSpace;
	background: #fff;
}
.top-wrapper {
	padding: 0 $pageSpace;
	height: 5rem;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: #fff;
	margin-bottom: 0.75rem;
}
.row-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}
.title-wrapper {
	height: 3.2rem;
	i {
		font-size: $mainFontSize;
		margin-right: 0.2rem;
	}
}
.subtitle-wrapper {
	height: 1.5rem;
	text-align: right;
}
.icon {
	width: 1.2rem;
	height: 1.2rem;
	font-size: 1.2rem;
	margin-right: 0.5rem;
}
.title {
	font-size: $subFontSize;
	color: $formInputColor;
	font-weight: 700;
}
.subtitle {
	font-size: $subFontSize;
	color: $descTextColor;
}
.price {
	font-size: $h2;
	color: $primaryColor;
	font-weight: 700;
}
.left-price {
	font-size: $h2;
	color: #48a1fb;
}
// .card {
// 	margin: 20px -20px;
// 	border: 1px solid darkgray;
// 	box-shadow: 0px 1px 8px rgb(8, 6, 6);
// 	padding: 15px;
// 	border-radius: 10px;
// }
.item-wrapper {
	height: 3.1rem;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	background-color: #fff;
	border-bottom: 1px solid $lineColor;
}
.item-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: stretch;
	background-color: #fff;
}
.item-left-wrapper {
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	i {
		background-image: url(../../../assets/image/wxpayicon.png);
		background-repeat: no-repeat;
		background-size: 100%;
	}
	.alipay_h5,
	.alipay_app {
		background-image: url(../../../assets/image/alipayicon.png);
	}
	.unionpay_h5 {
		background-image: url(../../../assets/image/unionpayicon.png);
	}
}
.item-right-wrapper {
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
}

.item-subtitle {
	font-size: $h2;
	color: #8c8c8c;
	margin-right: 0.25rem;
	text-align: right;
}
.item-select {
	font-size: 1.2rem;
	color: #7ed321;
}
.indicator {
	width: 0.7rem;
	height: 0.7rem;
	margin-left: 0.25rem;
	margin-right: 0.8rem;
}
.action-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 2.5rem;
	margin-top: 2.25rem;
}
</style>
